<template>
 <el-card>
        <el-collapse accordion>
         <el-collapse-item title="Create Certificate" name="1">
        <el-form label-width="180px">
          <el-form-item label="Online Course" >
        <el-select v-if="!loadingProducts" v-model="cert.online" @change="setProduct">
             <el-option
      v-for="product in online_courses"
      :key="product.id"
      :label="product.name"
      :value="product.id">
    </el-option>
        </el-select>
          </el-form-item>
                    <el-form-item label="Combined Course">
        <el-select v-if="!loadingProducts"  v-model="cert.combined" @change="setProduct"> 
             <el-option
      v-for="product in combined_courses"
      :key="product.id"
      :label="product.name"
      :value="product.id">
    </el-option>
        </el-select>
          </el-form-item>
                    <el-form-item label="Classroom Course">
        <el-select v-if="!loadingProducts" v-model="cert.classroom" @change="setProduct">
             <el-option
      v-for="product in classroom_courses"
      :key="product.id"
      :label="product.name"
      :value="product.id">
    </el-option>
        </el-select>

          </el-form-item>
          <el-form-item label="Set Date">
              <el-date-picker v-model="cert.date">
              </el-date-picker>
              <small class="text-muted">Leave Blank for todays date.</small>
          </el-form-item>
          <el-button type="primary" v-if="!certurl" :loading="loadingcert" @click="createCert">Create Certificate</el-button>
         <a class="btn btn-primary" :href="certurl" v-if="certurl">Download  Certificate</a>
        
   </el-form>
         </el-collapse-item>
        </el-collapse>
 </el-card>
</template>
<script>
import gql from 'graphql-tag'

import moment from "moment"
export default {
    props: ["customer"],
      data() {
    return {
        loadingProducts:false,
        online_courses:[],
        combined_courses:[],
        classroom_courses:[],
        cert:{product:null},
        certurl:'',
        loadingcert:false
    }
      },
    methods: {
      getProducts() {
        this.loadingProducts = true;
        this.$apollo
          .query({
            query: gql`
                        {
              Product(order_by: {name: asc}) {
                name
                id
                type
                isPublic
                
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
        })
        .then(response => {
          this.online_courses = response.data.Product.filter((c) =>  c.type==='online course');
          this.combined_courses = response.data.Product.filter((c) => c.type=='combined course');
          this.classroom_courses = response.data.Product.filter((c) => c.type==='classroom course');
          this.loadingProducts = false;
        })
      },
      setProduct(val){this.cert.product=val},
      createCert(){
          this.loadingcert=true
          api.createManualCert({customer_id:this.customer.id,product_id:this.cert.product,date:moment(this.cert.date).format("DD/MM/YYYY")}) 
          .then(res => {
         console.log(res)
         this.certurl=res.data
          this.loadingcert=false
        });
      }
  },
  mounted() {
     this.getProducts();
    //  this.initDepartures()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/CreateCert.vue